import { DesignTokens } from './design-tokens';
import { StyleProps, UIRoot } from './root';
import { Config } from './config';

export interface UIStyles {
  [selector: string]: StyleProps;
}

export interface UIConfig {
  designTokens?: DesignTokens;
  styles?: UIStyles;
  root?: UIRoot;
  config?: Config;
}
